module.exports = __webpack_public_path__ + "static/img/img04.e9ea102.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/en001/img04.jpg
// module id = hpl0
// module chunks = 0